import {DynamicSectionProps} from '../components/dynamic-section';

export const getDynamicSection =
  <T, D>(data: Omit<DynamicSectionProps<T, D>, 'type'>) =>
  (): DynamicSectionProps<T, D> => ({
    ...data,
    type: 'dynamic-section',
  });
